<template>
  <div>
    <v-dialog
        v-model="dialog"
        max-width="500px"
    >
      <template v-slot:activator="{ on }">
        <v-btn
            dark
            large
            icon
            text
            v-on="on"
            title="Add parcel tracking number"
        >
          <v-icon>mdi-email-plus</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-list-item dark class="indigo lighten-1 py-2">
          <v-list-item-avatar>
            <v-icon>mdi-email-plus</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="headline">Add parcel tracking</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click.stop="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-card-text>
          <v-form
              ref="form"
              v-model="valid"
              class="pt-4"
          >
            <v-autocomplete
                label="Courier Service"
                v-model="courier"
                :items="couriers"
                :rules="rules.courier"
                item-text="display_name"
                item-value="value"
                prepend-icon="mdi-truck"
                clearable
                outlined
            ></v-autocomplete>
            <v-text-field
                v-model="tracking"
                required
                :rules="rules.tracking"
                label="Tracking Number"
                prepend-icon="mdi-pound"
                outlined
            ></v-text-field>
            <v-textarea
                label="Description"
                v-model="description"
                prepend-icon="mdi-comment"
                outlined
                auto-grow
                rows="1"
            />
          </v-form>
        </v-card-text>
        <v-card-actions class="text-right">
          <div class="flex-grow-1"></div>
          <v-btn
              @click.stop="save()"
              text
              large
              color="secondary"
          >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {errorNotification} from "@/components/utils";

export default {
  components: {},
  name: 'CourierHistoryAddDialog',
  props: {
    id: Number,
  },
  data() {
    return {
      dialog: false,
      courier: null,
      tracking: '',
      description: '',
      couriers: [],
      valid: false,
      rules: {
        tracking: [
          v => !!v || 'Tracking is required',
        ],
        courier: [
          v => !!v || 'Courier Service is required',
        ],
      }
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isAdmin'
    ])
  },
  methods: {
    fetchOptions() {
      // Fetch possible options
      this.$axios.options('/application/courier/history/')
          .then((response) => {
            this.couriers = response.data.actions.POST.courier.choices
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$axios.post('/application/courier/history/', {
          application: this.id,
          courier: this.courier,
          from_agent: !this.isAdmin,
          tracking: this.tracking,
          description: this.description
        })
            .then(() => {
              this.$refs.form.reset()
              this.$emit('success')
              this.dialog = false
            })
            .catch((error) => {
              errorNotification(error)
            })

      }
    }
  },
  mounted() {
    this.fetchOptions()
  }
}
</script>